<!-- <div #captureSection>
	sme
	<p>
		Start editing to see some moidioephjagic happen :)
	</p>
</div> -->
<ng-container *ngIf="item">
	<div class="transaction-details-page">
		<section class="modal-body">
			<div nz-row>

				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="24">
							<strong class="f-16">
								{{item?.agent}}
							</strong>
						</div>
					</div>
				</div>
				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.account_name'|translate | titlecase}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold">
								{{item?.accountName}}
							</span>
						</div>
					</div>
				</div>
				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.account_no'|translate | titlecase}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold">
								{{item?.accountNumber}}
							</span>
						</div>
					</div>
				</div>
				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.bank'|translate | titlecase}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold">
								{{item?.bank}}
							</span>
						</div>
					</div>
				</div>
				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.amount' | translate}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold">
								{{'moniepoint.currency_symbol'| translate}} {{item.amount |
								majorAmount |
								currency}}
							</span>
						</div>
					</div>
				</div>
				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.customer_name'|translate | titlecase}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold">
								{{item?.customerName}}
							</span>
						</div>
					</div>
				</div>
				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.customer_number'|translate | titlecase}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold">
								{{item?.customerPhoneNumber}}
							</span>
						</div>
					</div>
				</div>
				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.channel'|translate | titlecase}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold">
								{{item?.channel}}
							</span>
						</div>
					</div>
				</div>
				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.serial_no'|translate | titlecase}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold">
								{{item?.serialNo}}
							</span>
						</div>
					</div>
				</div>

				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.narration'|translate | titlecase}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold">
								{{item?.narration}}
							</span>
						</div>
					</div>
				</div>

				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.created_on'|translate}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold">
								{{
								item.createdOn | date:'d MMM, y h:mm a'
								}}
							</span>
						</div>
					</div>
				</div>
				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.expires'|translate}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold">
								{{
								item.expiryDate | date:'d MMM, y h:mm a'
								}}
							</span>
						</div>
					</div>
				</div>
				<div nz-col nzSpan="24">
					<div nz-row>
						<div nz-col nzSpan="10">
							<span>{{'moniepoint.status'|translate}}:</span>
						</div>
						<div nz-col nzSpan="14">
							<span class="text-bold" [class]="'tag-'+ item.approvalStatus.toLowerCase()">
								{{ item.approvalStatus | titlecase }}
							</span>
						</div>
					</div>
				</div>

			</div>
			<ng-container
				*ngIf="!item.processing && item.approvalStatus === 'PENDING' && !item.expired && item.view !== 'agent'">
				<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-20">
					<div nz-col class="gutter-row" [nzSpan]="12">
						<button class="btn btn-secondary btn-block" (click)="doAction('decline')">
              {{'moniepoint.decline'|translate}}
						</button>
					</div>
					<div nz-col class="gutter-row" [nzSpan]="12">
						<app-custom-submit-button [block]="true" [name]="'Approve'" (click)="doAction('approve')">
						</app-custom-submit-button>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="item.approvalStatus === 'PENDING' && !item.expired && item.view === 'agent'">
				<div class="m-t-20">
					<app-custom-submit-button [block]="true" [name]="'Cancel'" (click)="doAction('approve')">
					</app-custom-submit-button>
				</div>
			</ng-container>
			<ng-container *ngIf="item.processing">
				<div nz-row class="actions-row text-bold">
					<div nz-col nzSpan="24" class="approve">
						<span class="approve text-bold loader">
							<i nz-icon nzType="loading" nzTheme="outline"></i></span>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="item.approvalStatus !== 'PENDING'">
				<div nz-row class="actions-row text-bold text-center">
					<div nz-col nzSpan="24" class="approve">
              <span class="text-bold treated"> {{'moniepoint.treated'|translate}}</span>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="item.expired && item.approvalStatus === 'PENDING'">
				<div nz-row class="actions-row text-bold text-center">
					<div nz-col nzSpan="24" class="approve">
						<span class="static text-bold">{{'moniepoint.expired'|translate}}</span>
					</div>
				</div>
			</ng-container>
		</section>
	</div>

</ng-container>

<!-- <ng-template #empty>
	<app-empty-state class="error-block" [obj]="emptyStateObj">
	</app-empty-state>
</ng-template> -->
